import React from "react";

// Faithful SVG recreation of the Sparko "sparko — schoonmaak diensten" logo.
// Fully transparent, scalable, themeable. dark=true => navy wordmark (light bg); false => white wordmark (dark bg).
export const SparkoLogo = ({ size = 30, dark = true, tagline = false, className = "" }) => {
  const wordColor = dark ? "#0A1F3C" : "#FFFFFF";
  const uid = React.useId();
  return (
    <span className={`inline-flex flex-col ${className}`} style={{ lineHeight: 1 }}>
      <span className="inline-flex items-end" style={{ position: "relative" }}>
        <span
          className="font-display"
          style={{ color: wordColor, fontSize: size, fontWeight: 800, letterSpacing: "-0.045em" }}
        >
          spark
        </span>
        {/* bubble "o" + decorations */}
        <svg width={size * 1.35} height={size * 1.55} viewBox="0 0 54 62" fill="none"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
          style={{ marginInlineStart: -size * 0.06, marginBottom: -size * 0.04 }}>
          <defs>
            <radialGradient id={`bub-${uid}`} cx="38%" cy="32%" r="75%">
              <stop offset="0%" stopColor="#7FC0FF" />
              <stop offset="45%" stopColor="#2C86F0" />
              <stop offset="100%" stopColor="#0B4FB0" />
            </radialGradient>
          </defs>
          {/* small soap bubbles */}
          <circle cx="33" cy="9" r="5" fill="none" stroke="#5DADEC" strokeWidth="1.4" opacity="0.9" />
          <circle cx="45" cy="6" r="2.4" fill="none" stroke="#7FC0FF" strokeWidth="1.1" opacity="0.8" />
          {/* sparkles */}
          <path d="M45 15 C45.6 18 46 18.4 49 19 C46 19.6 45.6 20 45 23 C44.4 20 44 19.6 41 19 C44 18.4 44.4 18 45 15Z" fill="#5DADEC" />
          <path d="M50 22 C50.4 23.8 50.7 24.1 52.5 24.5 C50.7 24.9 50.4 25.2 50 27 C49.6 25.2 49.3 24.9 47.5 24.5 C49.3 24.1 49.6 23.8 50 22Z" fill="#7FC0FF" />
          {/* main bubble = the letter o */}
          <circle cx="21" cy="40" r="18" fill={`url(#bub-${uid})`} />
          <ellipse cx="15" cy="33" rx="7" ry="4.5" fill="#FFFFFF" opacity="0.28" />
          {/* white 4-point sparkle inside */}
          <path d="M21 28 C22 37 23 38 33 40 C23 42 22 43 21 52 C20 43 19 42 9 40 C19 38 20 37 21 28Z" fill="#FFFFFF" />
          {/* swoosh */}
          <path d="M27 30 C33 31 35 34 34.5 39" stroke="#EAF4FF" strokeWidth="1.6" strokeLinecap="round" fill="none" opacity="0.85" />
        </svg>
      </span>
      {tagline && (
        <span className="inline-flex flex-col" style={{ marginTop: size * 0.06 }}>
          <span style={{ color: "#1E6FE0", fontSize: size * 0.26, fontWeight: 700, letterSpacing: "0.34em" }}>
            SCHOONMAAK DIENSTEN
          </span>
          <svg width="100%" height={size * 0.22} viewBox="0 0 220 12" preserveAspectRatio="none" style={{ marginTop: size * 0.04 }}>
            <path d="M2 8 C55 -2 120 12 218 3" stroke="#1E6FE0" strokeWidth="3" fill="none" strokeLinecap="round" />
          </svg>
        </span>
      )}
    </span>
  );
};

export default SparkoLogo;
